<template>
    <div class="card carousel-wrap">
        <v-carousel hide-delimiters>
            <v-carousel-item
                v-for="(item,i) in content"
                :key="i"
                :src="item.img_url"
                @click="OPEN_MODAL('slider_modal')"
            >
                <v-layout row align-center class="slider__bottom">
                    <v-flex v-show="!$vuetify.breakpoint.xs"
                            align-center
                            justify-center sm2 :class="{'d-flex':!$vuetify.breakpoint.xs}"
                            class="slider__bottom-num pa-4"
                    >{{ i+1 }} / {{ content.length }}</v-flex>
                    <v-flex d-flex align-center xs12
                            sm10
                            class="slider__bottom-text pa-3"
                    >{{ item.content }}</v-flex>
                </v-layout>
            </v-carousel-item>
        </v-carousel>
        <v-dialog :value="slider_modal" persistent content-class="scrolled-dialog">
            <sliderModal v-if="slider_modal" :content="content" />
        </v-dialog>
    </div>
</template>

<script>
import sliderModal from './slider_modal';
import {mapGetters, mapMutations, mapActions} from 'vuex';
export default {
  components: {
    sliderModal,
  },
  props: {
    content: {
      type: Array,
    },
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapGetters('common/modals', [
      'slider_modal',
    ]),
  },
  methods: {
    ...mapMutations('common/modals', [
      'OPEN_MODAL',
    ]),
  },

};
</script>

